import { useState } from 'react';
import { 
  FaFilter, 
  FaSearch, 
  FaTimes,
  FaRedo,
  FaSortAmountDown,
  FaSortAmountUp
} from 'react-icons/fa';

const MouvementFilters = ({
  onFilterChange,
  isLoading = false,
  initialFilters = {},
  disabled = false
}) => {
  // ✅ États locaux complètement indépendants
  const [accountName, setAccountName] = useState(initialFilters.accountName || '');
  const [securityName, setSecurityName] = useState(initialFilters.securityName || '');
  const [categorie, setCategorie] = useState(initialFilters.categorie || '');
  const [sortOrder, setSortOrder] = useState(initialFilters.sortOrder || '');

  // ✅ Fonction qui remonte TOUT l'objet filters
  const notifyChange = (updates) => {
    const newFilters = {
      accountName,
      securityName,
      categorie,
      sortOrder,
      ...updates
    };
    onFilterChange(newFilters);
  };

  const handleAccountChange = (value) => {
    setAccountName(value);
    notifyChange({ accountName: value });
  };

  const handleSecurityChange = (value) => {
    setSecurityName(value);
    notifyChange({ securityName: value });
  };

  const handleCategorieChange = (value) => {
    setCategorie(value);
    notifyChange({ categorie: value });
  };

  const handleSortChange = (order) => {
    const newSort = sortOrder === order ? '' : order;
    setSortOrder(newSort);
    notifyChange({ sortOrder: newSort });
  };

  const handleReset = () => {
    setAccountName('');
    setSecurityName('');
    setCategorie('');
    setSortOrder('');
    onFilterChange({
      accountName: '',
      securityName: '',
      categorie: '',
      sortOrder: ''
    });
  };

  const activeFilters = [accountName, securityName, categorie, sortOrder].filter(Boolean).length;

  return (
    <div className="search-filter-container mb-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
        
        <div className="d-flex align-items-center gap-2">
          <FaFilter className="text-primary" size={20} />
          <h6 className="fw-bold mb-0">Mouvements</h6>
        </div>
        
        <div className="filter-controls d-flex flex-wrap align-items-center gap-2">
          
          {/* Recherche Compte */}
          <div className="position-relative">
            <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-2 text-muted" size={16} />
            <input 
              type="text" 
              className="search-input ps-4" 
              placeholder="Compte..." 
              value={accountName} 
              onChange={e => handleAccountChange(e.target.value)}
              disabled={isLoading || disabled}
              style={{ 
                height: '38px',
                outline: 'none',
                boxShadow: 'none',
                borderColor: accountName ? '#0d6efd' : '#dee2e6',
                width: '260px'
              }}
            />
            {accountName && (
              <button
                className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0"
                onClick={() => handleAccountChange('')}
                type="button"
                style={{ color: '#6c757d', outline: 'none', boxShadow: 'none' }}
              >
                <FaTimes size={14} />
              </button>
            )}
          </div>
          
          {/* Recherche Titre */}
          <div className="position-relative">
            <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-2 text-muted" size={16} />
            <input 
              type="text" 
              className="search-input ps-4" 
              placeholder="Titre..." 
              value={securityName} 
              onChange={e => handleSecurityChange(e.target.value)}
              disabled={isLoading || disabled}
              style={{ 
                height: '38px',
                outline: 'none',
                boxShadow: 'none',
                borderColor: securityName ? '#0d6efd' : '#dee2e6',
                width: '250px'
              }}
            />
            {securityName && (
              <button
                className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0"
                onClick={() => handleSecurityChange('')}
                type="button"
                style={{ color: '#6c757d', outline: 'none', boxShadow: 'none' }}
              >
                <FaTimes size={14} />
              </button>
            )}
          </div>
          
          {/* Catégorie */}
          <select 
            className="account-type-select" 
            onChange={(e) => handleCategorieChange(e.target.value)}
            value={categorie}
            disabled={isLoading || disabled}
            style={{ height: '38px', outline: 'none', width: '150px' }}
          >
            <option value="">Catégorie</option>
            <option value="Commission Trimestrielle">Commission</option>
            <option value="Cash">Cash</option>
            <option value="Achat Titre">Achat Titre</option>
            <option value="Vente Titre">Vente Titre</option>
            <option value="Retrait">Retrait</option>
            <option value="Dépôt">Dépôt</option>
          </select>
          
          {/* Tri Date */}
          <button 
            className={`filter-button ${sortOrder === 'date_desc' || sortOrder === 'date_asc' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => handleSortChange(sortOrder === 'date_desc' ? 'date_asc' : 'date_desc')}
            disabled={isLoading || disabled}
            style={{ height: '38px', padding: '0 12px', outline: 'none' }}
          >
            {sortOrder === 'date_desc' ? <FaSortAmountDown size={14} /> :
             sortOrder === 'date_asc' ? <FaSortAmountUp size={14} /> :
             <FaSortAmountDown size={14} className="text-muted" />}
          </button>
          
          {/* Tri Montant */}
          <button 
            className={`filter-button ${sortOrder === 'montant_desc' || sortOrder === 'montant_asc' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => handleSortChange(sortOrder === 'montant_desc' ? 'montant_asc' : 'montant_desc')}
            disabled={isLoading || disabled}
            style={{ height: '38px', padding: '0 12px', outline: 'none' }}
          >
            {sortOrder === 'montant_desc' ? <FaSortAmountDown size={14} /> :
             sortOrder === 'montant_asc' ? <FaSortAmountUp size={14} /> :
             <FaSortAmountDown size={14} className="text-muted" />}
          </button>
          
          {activeFilters > 0 && (
            <>
              <button 
                className="refresh-button d-flex align-items-center gap-1"
                onClick={handleReset}
                disabled={isLoading || disabled}
                style={{ height: '38px', padding: '0 12px', outline: 'none' }}
              >
                <FaRedo size={14} />
                <span>Effacer</span>
              </button>
              
              <span className="badge bg-primary bg-opacity-10 text-primary border border-primary rounded-pill px-2 py-1">
                {activeFilters}
              </span>
            </>
          )}
          
          {isLoading && (
            <div className="spinner-border spinner-border-sm text-muted" style={{ width: '12px', height: '12px' }}>
              <span className="visually-hidden">Chargement...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MouvementFilters;